export const Footer = () => {
  return (
    <footer
      className="mt-20 border-t border-[#0268A0] bg-gradient-to-r from-[#0077B6] via-[#0A5EA5] to-[#7F3A9A] py-16 text-white"
      data-testid="site-footer"
    >
      <div className="section-container grid gap-10 md:grid-cols-[2fr_1fr_1fr] md:items-end">
        <div data-testid="footer-brand-block">
          <p className="text-xs uppercase tracking-[0.2em] text-white/75" data-testid="footer-kicker-text">
            Marca corporativa
          </p>
          <div className="mt-3" data-testid="footer-logo-wrapper">
            <div
              className="inline-flex h-[108px] w-[360px] max-w-full items-center justify-center overflow-hidden rounded-md border border-white/70 bg-white p-2"
              data-testid="footer-isotype-logo-frame"
            >
              <img
                src="/logo-erp-isotipo.png"
                alt="Logo ERP Pragmatic con isotipo"
                className="h-full w-full object-contain object-center"
                data-testid="footer-isotype-logo-image"
              />
            </div>
          </div>
          <h2 className="corporate-title-balance mt-5 text-3xl sm:text-4xl lg:text-5xl" data-testid="footer-brand-title">
            Soluciones que convierten estrategia en resultados.
          </h2>
        </div>

        <div data-testid="footer-links-company">
          <h3 className="text-sm font-semibold uppercase tracking-[0.14em] text-white/85" data-testid="footer-company-heading">
            Compañía
          </h3>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            <li data-testid="footer-company-item-expertise">Consultoría estratégica</li>
            <li data-testid="footer-company-item-operational">Transformación operacional</li>
            <li data-testid="footer-company-item-growth">Crecimiento sostenible</li>
          </ul>
        </div>

        <div data-testid="footer-copyright-block">
          <p className="text-sm text-white/70" data-testid="footer-copyright-text">
            © {new Date().getFullYear()} Pragmatic XXI.
          </p>
          <p className="mt-2 text-xs uppercase tracking-[0.12em] text-white/60" data-testid="footer-location-text">
            Santiago de Chile
          </p>
        </div>
      </div>
    </footer>
  );
};
